import React from "react";
import { Box, Button, Paper, Stack, Typography } from "@mui/material";
import { createStyles, palette, spacing } from "../../../styles/theme";
import SpecsNumberField from "./SpecsNumberField";
import { SpecsInputField } from "../SpecsEditorFields/index";
import { readObjectArray, type JsonObject } from "./utils";

const styles = createStyles({
  rowPaper: {
    p: spacing.groupingDesktop,
    border: `1px solid ${palette.grey.lightGrey}`,
  },
});

export default function SpecsChargeExtraSizeField({
  label,
  value,
  debugPath,
  clickToEdit,
  onChange,
}: {
  label: string;
  value: unknown;
  debugPath?: string;
  clickToEdit?: boolean;
  onChange: (nextValue: unknown) => void;
}) {
  const rows = readObjectArray(value);

  const updateRows = React.useCallback(
    (nextRows: JsonObject[]) => {
      onChange(nextRows);
    },
    [onChange]
  );

  return (
    <Stack spacing={1.5}>
      <Stack direction="row" spacing={1} alignItems="center">
        <Typography variant="subtitle2">{label}</Typography>
        <Box sx={{ flex: 1 }} />
        <Button
          variant="outlined"
          size="small"
          onClick={() => updateRows([...rows, {}])}
        >
          Add Size Rule
        </Button>
      </Stack>

      {rows.map((row, index) => {
        const { sizeName, sizeFreeWithOrderAbove } = row;

        return (
          <Paper key={index} variant="outlined" sx={styles.rowPaper}>
            <Stack spacing={1.5}>
              <Stack direction="row" spacing={1} alignItems="center">
                <Typography variant="subtitle2">Rule {index + 1}</Typography>
                <Box sx={{ flex: 1 }} />
                <Button
                  variant="outlined"
                  size="small"
                  color="inherit"
                  onClick={() =>
                    updateRows(
                      rows.filter(
                        (_candidate, candidateIndex) => candidateIndex !== index
                      )
                    )
                  }
                >
                  Supprimer
                </Button>
              </Stack>

              <SpecsInputField
                label="Size Name"
                value={typeof sizeName === "string" ? sizeName : ""}
                debugPath={
                  debugPath ? `${debugPath}.${index}.sizeName` : undefined
                }
                clickToEdit={clickToEdit}
                onChange={(event) =>
                  updateRows(
                    rows.map((candidate, candidateIndex) =>
                      candidateIndex === index
                        ? { ...candidate, sizeName: event.target.value }
                        : candidate
                    )
                  )
                }
              />

              <SpecsNumberField
                label="Size Free With Order Above"
                value={
                  typeof sizeFreeWithOrderAbove === "number"
                    ? sizeFreeWithOrderAbove
                    : null
                }
                allowNull
                debugPath={
                  debugPath
                    ? `${debugPath}.${index}.sizeFreeWithOrderAbove`
                    : undefined
                }
                clickToEdit={clickToEdit}
                onChange={(nextValue) =>
                  updateRows(
                    rows.map((candidate, candidateIndex) =>
                      candidateIndex === index
                        ? {
                            ...candidate,
                            ...(nextValue === null
                              ? {}
                              : { sizeFreeWithOrderAbove: nextValue }),
                          }
                        : candidate
                    )
                  )
                }
              />
            </Stack>
          </Paper>
        );
      })}
    </Stack>
  );
}
